import { render, staticRenderFns } from "./weixin_account.vue?vue&type=template&id=6d9249fc&"
import script from "./weixin_account.vue?vue&type=script&lang=ts&"
export * from "./weixin_account.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports